import * as React from 'react';
export const callSvg = React.forwardRef(function callSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.016 2.008a.75.75 0 0 0-.33 1.463 3.69 3.69 0 0 1 1.803 1.01c.522.521.86 1.146 1.009 1.804a.75.75 0 0 0 1.463-.33 5.191 5.191 0 0 0-1.41-2.536 5.197 5.197 0 0 0-2.535-1.411Zm-1.712 3.22a.75.75 0 0 1 .91-.545 2.844 2.844 0 0 1 1.328.747c.383.383.627.846.747 1.328a.75.75 0 1 1-1.455.364 1.345 1.345 0 0 0-.353-.632 1.343 1.343 0 0 0-.632-.352.75.75 0 0 1-.545-.91Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.448 1.061A1.91 1.91 0 0 1 3.805.5a1.89 1.89 0 0 1 1.643.943l1.368 2.3a1.745 1.745 0 0 1-.263 2.13l-.49.49-.008.008c-.155.145-.18.419.015.617l2.941 2.897.01.011c.146.155.417.18.614-.017l.48-.481c.59-.59 1.445-.657 2.135-.262l.012.007 2.298 1.372c.638.37.94 1.031.94 1.66v.01a1.92 1.92 0 0 1-.56 1.332c-1.168 1.171-2.648 1.983-4.44 1.983a5.85 5.85 0 0 1-4.148-1.733L2.228 9.634A5.85 5.85 0 0 1 .5 5.5m1.948-4.439C1.276 2.236.5 3.73.5 5.501ZM3.804 2a.41.41 0 0 0-.294.12C2.557 3.077 2 4.206 2 5.5c0 1.108.436 2.219 1.29 3.075l4.124 4.133A4.351 4.351 0 0 0 10.5 14c1.297 0 2.414-.576 3.379-1.543a.415.415 0 0 0 .12-.286.404.404 0 0 0-.194-.36l-.01-.006-2.295-1.37c-.149-.083-.252-.049-.323.022l-.48.482c-.76.76-2.002.79-2.759-.005L5.01 8.049c-.76-.76-.787-2.004.008-2.762l.473-.474a.242.242 0 0 0 .039-.296l-.003-.005L4.15 2.195A.39.39 0 0 0 3.804 2Z',
    }),
  );
});
callSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var call = {
  category: 'icon',
  colorable: true,
  name: 'call',
  svg: callSvg,
};
